var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_888_11610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_888_11610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7 21.575L5.275 13.175C5.175 13.075 5.10417 12.9667 5.0625 12.85C5.02083 12.7333 5 12.6083 5 12.475C5 12.3417 5.02083 12.2167 5.0625 12.1C5.10417 11.9833 5.175 11.875 5.275 11.775L13.7 3.35C13.9333 3.11667 14.225 3 14.575 3C14.925 3 15.225 3.125 15.475 3.375C15.725 3.625 15.85 3.91667 15.85 4.25C15.85 4.58333 15.725 4.875 15.475 5.125L8.125 12.475L15.475 19.825C15.7083 20.0583 15.825 20.3458 15.825 20.6875C15.825 21.0292 15.7 21.325 15.45 21.575C15.2 21.825 14.9083 21.95 14.575 21.95C14.2417 21.95 13.95 21.825 13.7 21.575Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/arrow-left-white.5ad3411acde79d826ed5921f3672b237.svg";
export { ForwardRef as ReactComponent };